import '../Logistic/logistic.css';
import html2pdf from 'html2pdf.js/dist/html2pdf.min';
import ReactDOMServer from 'react-dom/server';
import './invoice.css';
import QRCode from 'react-qr-code';
import nmLogo from '.././../../assets/images/nm_logo.png';
import paymentQr from '.././../../assets/images/payment_qr.png';
import dayjs from 'dayjs';
import moment from 'moment';
import { toWordsPrice } from '../../../helpers/InWord';

function formatDate(inputDate) {
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];

    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
}


const invoiceBill = (data) => {
    return (
        <div className='header-invoice'>
            <div>
                <div className='header-in d-flex align-items-center'>
                    <div style={{ width: '190px' }}>
                        <img src={nmLogo} alt='NM Logo' />
                    </div>
                    <div className='right-sec'>
                        <h6 className='tax-heading'>Tax Invoice</h6>
                        <h3 className='company_name'>NM India Bio Private Limited</h3>
                        <div className='invoice-address'>
                            Araji No. 4790, Jhamar Kotra Road, Umarda, Udaipur ,
                            Rajasthan - 313003, INDIA.
                        </div>
                        <div className='my-0 invoice-address '>
                            <span>9829355044</span>
                            <span className='mx-3'>bhanuprakash@nmidiabio.com</span>
                        </div>
                        <div className='invoice-address'>
                            <span>
                                GSTIN: <b>08AACCE7746A1ZT</b>
                            </span>
                            <span className='mx-3'>
                                PAN: <b>AACCE7746A</b>
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='invoice-bill mt-3'>
                        <div className='invoice-bill-content'>
                            <div className='invoice-date'>
                                <span>INVOICE</span>
                                <br></br>
                                <span>{data?.vch_no}</span>
                                <br></br>
                                <span>{formatDate(data?.parsedReplacements?.date)}</span>
                            </div>
                            <div className='invoice-person-detail'>
                                <p style={{ marginBottom: '0' }}>Bill to</p>
                                <div className='tax-heading'>
                                    {data?.parsedReplacements?.tallyLedgerName}
                                </div>
                                <span>Dealer Code : </span>
                                <br></br>
                                <span>
                                    {data?.parsedReplacements?.billing_address} ,{' '}
                                    {data?.parsedReplacements?.billing_city} ,{' '}
                                    {data?.parsedReplacements?.billing_state} ,{' '}
                                    {data?.parsedReplacements?.billing_zip}
                                </span>
                                <br></br>
                                <span>
                                    GSTIN : {data?.parsedReplacements?.gstin} (24){' '}
                                    {data?.parsedReplacements?.billing_state}
                                </span>
                            </div>
                        </div>
                        <div
                            className='invoice-person-detail'
                            style={{ borderLeft: '1px solid black' }}
                        >
                            <p style={{ marginBottom: '0' }}>Ship to</p>
                            <div className='tax-heading'>
                                {data?.parsedReplacements?.tallyLedgerName}
                            </div>
                            <span>Dealer Code : </span>
                            <br></br>
                            <span>
                                {data?.parsedReplacements?.shipping_address} ,{' '}
                                {data?.parsedReplacements?.shipping_city} ,{' '}
                                {data?.parsedReplacements?.shipping_state} ,{' '}
                                {data?.parsedReplacements?.shipping_zip}
                            </span>
                            <br></br>
                            <span>
                                GSTIN : {data?.parsedReplacements?.gstin} (24){' '}
                                {data?.parsedReplacements?.shipping_state}
                            </span>
                        </div>
                        <div className='invoice-bill-qrcode'>
                            <img src={paymentQr} style={{ width: '100px' }} />
                        </div>
                    </div>

                    <table className='mid-line-table'>
                        <tr>
                            <th className='first-th'>IRN</th>
                            <th>{data?.irnNumber}</th>
                            <th>{data?.irnAckNumber}</th>
                            <th>@ {dayjs(data?.irnAckDate).format('DD-MMM-YYYY')}</th>
                        </tr>
                    </table>

                    <table>
                        <tr>
                            <th></th>
                            <th>Order</th>
                            <th>Dispatch Doc</th>
                            <th>Through</th>
                            <th>LR/RR/BL</th>
                            <th>Carrier</th>
                        </tr>

                        <tr>
                            <td>#</td>
                            <td>{data?.parsedReplacements?.ordersNumbers ? data?.parsedReplacements?.ordersNumbers : data?.order_no}</td>
                            <td>{data?.vch_no}</td>
                            <td>{data?.parsedReplacements?.transporterName}</td>
                            <td>{data?.parsedReplacements?.products[0]?.lr_no}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>@</td>
                            <td>{formatDate(data?.parsedReplacements?.date)}</td>
                            <td></td>
                            <td></td>
                            <td className='date'>
                                {formatDate(data?.parsedReplacements?.date)}{' '}
                            </td>
                            <td>{data?.parsedReplacements?.carrierNumber}</td>
                        </tr>
                    </table>

                    <table className='main-table'>
                        <thead>
                            <tr>
                                <th className='s_no'>S.No</th>
                                <th className='product_name_td'>Description of Goods</th>
                                <th className='hsn_td1'>HSN</th>
                                <th>Quantity</th>
                                <th>Weight</th>
                                <th>Carton</th>
                                <th>Rate</th>
                                <th>Per</th>
                                <th>Disc. %</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.stockList?.map(
                                (product, index) => (
                                    <>
                                        <tr className='border-0' key={index}>
                                            <td>{index + 1}</td>
                                            <td className='product_name_td'>
                                                {product?.product_name}
                                            </td>
                                            <td>310100</td>
                                            <td>{`${product?.quantity}`}</td>
                                            <td>{`${product?.weight || ''} ${product?.unit || ''}`}</td>
                                            <td>-</td>
                                            <td>{product?.rate}</td>
                                            <td>{product?.base_unit}</td>
                                            <td>-</td>
                                            <td>{product?.item_amount}</td>
                                        </tr>
                                    </>
                                )
                            )}
                            <tr className='border-0' style={{ height: '30px' }}>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className=''>
                                    {/* <hr style={{border:'1px solid #000',paddingRight:'5px'}}/> */}
                                    <b>-</b>
                                </td>
                            </tr>

                            {data?.ledgerList?.find(list => list.name.toLowerCase().includes('discount')) && (
                                <tr className='border-0'>
                                    <td></td>
                                    <td
                                        className='d-flex justify-content-between'
                                        style={{ paddingRight: '5px' }}
                                    >
                                        <b></b>
                                        <b>
                                            <i>
                                                {
                                                    data?.parsedReplacements?.ledgerRows?.discount
                                                        ?.name
                                                }
                                            </i>
                                        </b>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <b>
                                            (-) {' '}
                                            {
                                                (-Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('discount'))?.amount)).toFixed(2)
                                            }
                                        </b>
                                    </td>
                                </tr>
                            )}

                            {data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst')) && (
                                <tr className='border-0'>
                                    <td></td>
                                    <td
                                        className='d-flex justify-content-between'
                                        style={{ paddingRight: '5px' }}
                                    >
                                        <b></b>
                                        <b>
                                            <i>CGST</i>
                                        </b>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <b>{data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst'))?.amount}</b>
                                    </td>
                                </tr>
                            )}

                            {data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst')) && (
                                <tr className='border-0'>
                                    <td></td>
                                    <td
                                        className='d-flex justify-content-between'
                                        style={{ paddingRight: '5px' }}
                                    >
                                        <b></b>
                                        <b>
                                            <i>SGST</i>
                                        </b>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <b>{data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst'))?.amount}</b>
                                    </td>
                                </tr>
                            )}
                            {data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst')) && (
                                <tr className='border-0'>
                                    <td></td>
                                    <td
                                        className='d-flex justify-content-between'
                                        style={{ paddingRight: '5px' }}
                                    >
                                        <b></b>
                                        <b>
                                            <i>IGST</i>
                                        </b>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <b>
                                            {data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst'))?.amount}
                                        </b>
                                    </td>
                                </tr>
                            )}

                            <tr style={{ height: '200px' }} className='border-0'>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <b>Total Amount</b>
                                </td>
                                <td></td>
                                <td>
                                    <b>
                                        {data?.parsedReplacements?.quantity}{' '}
                                        {data?.parsedReplacements?.baseUnit}
                                    </b>
                                </td>
                                <td>{data?.parsedReplacements?.total_weight}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    <b>
                                        Rs. {-Number((data?.ledgerList?.find(list => list.name === data?.parsedReplacements?.tallyLedgerName)?.amount)).toFixed(2)}
                                    </b>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table className='amount-chargeble'>
                        <tbody>
                            <div
                                className='d-flex'
                                style={{
                                    borderLeft: '1px solid #000',
                                    borderRight: '1px solid #000',
                                }}
                            >
                                <div
                                    style={{
                                        borderRight: '1px solid #000',
                                        width: '80%',
                                        padding: '0px 5px',
                                    }}
                                >
                                    <div className='d-flex justify-content-between amount-words'>
                                        <p className='m-0 amount'>
                                            <b>Amount Chargeable (In words)</b>
                                        </p>
                                        <p className='mx-1 mb-0 eof text-right'>
                                            <b>E. & O.E</b>
                                        </p>
                                    </div>
                                    <div className='mb-0 amount-eng'>
                                        <b>INR {toWordsPrice(-Number((data?.ledgerList?.find(list => list.name === data?.parsedReplacements?.tallyLedgerName)?.amount)))} only</b>
                                    </div>
                                    <p></p>
                                </div>

                                <div style={{ padding: '0px 5px', margin: 'auto' }}>
                                    <div className='d-flex justify-content-between'>
                                        <b>Freight Payable :</b>
                                        <b style={{ paddingLeft: '5px' }}>
                                            {' '}
                                            {
                                                data?.parsedReplacements?.products[0]
                                                    ?.freight_amount
                                            }
                                            .00
                                        </b>
                                    </div>
                                    <div className='d-flex justify-content-between'>
                                        <b>Due Amount :</b>
                                        <b style={{ paddingLeft: '5px' }}> 00.00</b>
                                    </div>
                                </div>
                            </div>
                        </tbody>
                    </table>

                    <table className='tax-amount'>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}>HSN/SAC</th>
                                <th style={{ width: '15%', textAlign: 'center' }}>
                                    Taxable Value
                                </th>
                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst')) && (
                                    <th className='p-0' style={{ width: '15%' }}>
                                        <div
                                            className='text-center'
                                            style={{ borderBottom: '1px solid #000' }}
                                        >
                                            <b style={{ fontWeight: 'bold' }}>Central Tax</b>
                                        </div>
                                        <div className='d-flex justify-content-around'>
                                            <b
                                                style={{
                                                    fontWeight: 'bold',
                                                    padding: '0px 5px',
                                                    width: '53px',
                                                }}
                                            >
                                                Rate
                                            </b>
                                            <b style={{ borderRight: '1px solid #000' }}></b>
                                            <b
                                                style={{
                                                    fontWeight: 'bold',
                                                    padding: '0px 5px',
                                                }}
                                            >
                                                Amount
                                            </b>
                                        </div>
                                    </th>
                                )}

                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst')) && (
                                    <th className='p-0' style={{ width: '15%' }}>
                                        <div
                                            className='text-center'
                                            style={{ borderBottom: '1px solid #000' }}
                                        >
                                            <b style={{ fontWeight: 'bold' }}>State Tax</b>
                                        </div>
                                        <div className='d-flex justify-content-around'>
                                            <b
                                                style={{
                                                    fontWeight: 'bold',
                                                    padding: '0px 5px',
                                                    width: '53px',
                                                }}
                                            >
                                                Rate
                                            </b>
                                            <b style={{ borderRight: '1px solid #000' }}></b>
                                            <b
                                                style={{
                                                    fontWeight: 'bold',
                                                    padding: '0px 5px',
                                                }}
                                            >
                                                Amount
                                            </b>
                                        </div>
                                    </th>
                                )}

                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst')) && (
                                    <th className='p-0' style={{ width: '15%' }}>
                                        <div
                                            className='text-center'
                                            style={{ borderBottom: '1px solid #000' }}
                                        >
                                            <b style={{ fontWeight: 'bold' }}>Integrated Tax</b>
                                        </div>
                                        <div className='d-flex justify-content-around'>
                                            <b
                                                style={{
                                                    fontWeight: 'bold',
                                                    padding: '0px 5px',
                                                    width: '53px',
                                                }}
                                            >
                                                Rate
                                            </b>
                                            <b style={{ borderRight: '1px solid #000' }}></b>
                                            <b
                                                style={{
                                                    fontWeight: 'bold',
                                                    padding: '0px 5px',
                                                }}
                                            >
                                                Amount
                                            </b>
                                        </div>
                                    </th>
                                )}
                                <th style={{ width: '15%', textAlign: 'center' }}>
                                    Total Tax Amount
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ textAlign: 'center' }}>310100</td>
                                <td style={{ width: '15%', textAlign: 'center' }}>
                                    {data?.stockList?.reduce((acc, product) => acc + Number(product?.item_amount), 0)
                                        - (-Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('discount'))?.amount) || 0)}
                                </td>

                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst')) && (
                                    <>
                                        <td className='p-0' style={{ width: '15%' }}>
                                            <div className='d-flex justify-content-around'>
                                                <div
                                                    style={{
                                                        fontWeight: 'none',
                                                        padding: '0px 5px',
                                                    }}
                                                >
                                                    {data?.parsedReplacements?.itemsTax?.cgst}%
                                                </div>
                                                <div
                                                    style={{ borderRight: '1px solid #000' }}
                                                ></div>
                                                <div style={{ padding: '0px 5px' }}>
                                                    {data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst'))?.amount}
                                                </div>
                                            </div>
                                        </td>
                                    </>
                                )}

                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst')) && (
                                    <>
                                        <td className='p-0' style={{ width: '15%' }}>
                                            <div className='d-flex justify-content-around'>
                                                <div
                                                    style={{
                                                        fontWeight: 'none',
                                                        padding: '0px 5px',
                                                    }}
                                                >
                                                    {data?.parsedReplacements?.itemsTax?.sgst}%
                                                </div>
                                                <div
                                                    style={{ borderRight: '1px solid #000' }}
                                                ></div>
                                                <div style={{ padding: '0px 5px' }}>
                                                    {data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst'))?.amount}
                                                </div>
                                            </div>
                                        </td>
                                    </>
                                )}

                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst')) && (
                                    <>
                                        <td className='p-0' style={{ width: '15%' }}>
                                            <div className='d-flex justify-content-around'>
                                                <div
                                                    style={{
                                                        fontWeight: 'none',
                                                        padding: '0px 5px',
                                                    }}
                                                >
                                                    {data?.parsedReplacements?.itemsTax?.igst}%
                                                </div>
                                                <div
                                                    style={{ borderRight: '1px solid #000' }}
                                                ></div>
                                                <div style={{ padding: '0px 5px' }}>
                                                    {
                                                        data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst'))?.amount
                                                    }
                                                </div>
                                            </div>
                                        </td>
                                    </>
                                )}

                                <td style={{ width: '15%', textAlign: 'center' }}>
                                    {Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst'))?.amount || 0) + Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst'))?.amount || 0) + Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst'))?.amount || 0)}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className='pt-2 pl-1 bank_details d-flex justify-content-between border border-dark'>
                        <div className='d-flex flex-column justify-content-between w-50 pr-4'>
                            <span>
                                Tax Amount (in Words) :<br />
                                <b>INR {toWordsPrice(Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst'))?.amount || 0) + Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst'))?.amount || 0) + Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst'))?.amount || 0))}</b>
                                {/* <!-- Enter amount in words  --> */}
                            </span>
                            <div>
                                <p className='mb-0 pt-2'>
                                    <p
                                        className='mb-0'
                                        style={{ textDecoration: 'underline' }}
                                    >
                                        Declaration :
                                    </p>
                                    We Declare that this invoice shows the real price of the
                                    goods described and that all particular true and
                                    correct.
                                </p>
                            </div>
                        </div>
                        <div className='company_div w-50'>
                            <div className='mt-0'>
                                <p className='mb-0'>Company's Bank Details</p>
                                <p className='mb-0'>
                                    Bank Name : <b>Bank of Baroda (India)</b>
                                </p>
                                <p className='mb-0'>
                                    A/c No. : <b>01370500000868</b>
                                </p>
                                <p className='mb-0'>
                                    Branch & IFSC Code :{' '}
                                    <b>Udaipur Main Branch & BARB0UDAIPU</b>
                                </p>
                            </div>
                            <div
                                className='invoice-bill-qrcode qr-code border border-dark w-100 h-100 p-1'
                                style={{ borderBottom: '0px !important' }}
                            >
                                <div>
                                    <div className='text-left'>
                                        <b>Scan to Pay</b>
                                    </div>
                                    <div className='mt-1'>
                                        <img src={paymentQr} style={{ width: '100px' }} />
                                    </div>
                                </div>
                                <div className='d-flex flex-column justify-content-between mt-3'>
                                    <p style={{ fontWeight: '600' }}>
                                        For{' '}
                                        <span style={{ fontWeight: 'bold' }}>
                                            NM India Bio Private Limited
                                        </span>{' '}
                                    </p>
                                    <p className='mb-0'>Authorized Signatory</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='border border-dark text-center p-2 border-top-0'>
                        This is a computer generated Invoice
                    </div>



                </div>
            </div>
        </div>
    )
}


const ewayBill = (data) => {
    return (
        <div className='p-0 mt-5' style={{ pageBreakAfter: 'always' }}>
            <div className='header bg-none mb-2'>
                <h6>e-Way Bill</h6>
            </div>

            <div className='invoiceSectionBorderBottom'>
                <div>
                    <p>
                        Doc No :{' '}
                        <span className='boldText'>
                            {' '}
                            {data?.ewayBillData?.transportDetails?.documentNumber}
                        </span>
                    </p>
                    <p>
                        Date :
                        <span className='boldText'>
                            {' '}
                            {moment(
                                data?.ewayBillData?.transportDetails?.documentDate,
                                'YYYYMMDD'
                            ).format('DD-MMM-YYYY')}
                        </span>
                    </p>
                    <p>
                        IRN :
                        <span className='boldText'>
                            {' '}
                            {data?.irnNumber}
                        </span>
                    </p>
                    <p>
                        Ack No :
                        <span className='boldText'>
                            {' '}
                            {data?.irnAckNumber}
                        </span>
                    </p>
                    <p>
                        Ack Date :
                        <span className='boldText'>
                            {' '}
                            {moment(
                                data?.basicOrderDate,
                                'YYYYMMDD'
                            ).format('DD-MMM-YYYY')}
                        </span>
                    </p>
                </div>
                <div>
                    {' '}
                    <QRCode
                        title='GeeksForGeeks'
                        value={data?.ewayBillData?.qrCode}
                        bgColor={'#ffffff'}
                        fgColor={'#000000'}
                        size={100}
                    />
                </div>
            </div>

            {/* <h3>1. e-Way Bill Details</h3> */}
            <div className='boldText p-1'>1. e-Way Bill Details</div>
            <div className='invoiceSectionBorderBottom'>
                <div>
                    <p>
                        e-Way Bill No :
                        <span className='boldText'>
                            {' '}
                            {data?.ewayBillData?.billNumber}
                        </span>
                    </p>
                    <p>
                        Generated By :
                        <span className='boldText'> 08AACCE7746A1ZT</span>
                    </p>
                    <p>
                        Supply Type :
                        <span className='boldText'> Outward</span>
                    </p>
                </div>
                <div>
                    <p>
                        Mode :<span className='boldText'> {data?.ewayBillData?.transportDetails?.modeOfTransport}</span>
                    </p>
                    <p>
                        Approx Distance :
                        <span className='boldText'>
                            {
                                data?.ewayBillData?.transportDetails?.distance
                            }
                        </span>
                    </p>
                    <p>
                        Transition Type :
                        <span className='boldText'> Bill To - Ship To</span>
                    </p>
                </div>
                <div>
                    <p>
                        Generated Date :
                        <span className='boldText'>
                            {moment(
                                data?.ewayBillData?.updatedOn,
                                'YYYYMMDDHHmmssSSS'
                            ).format('DD-MMM-YYYY hh:mm:A')}
                        </span>
                    </p>
                    <p>
                        Valid Upto :
                        <span className='boldText'>
                            {' '}
                            {moment(
                                data?.ewayBillData?.validUpto,
                                'YYYYMMDDHHmmssSSS'
                            ).format('DD-MMM-YYYY hh:mm:A')}
                        </span>
                    </p>
                </div>
            </div>

            {/* <h3>2. Address Details</h3> */}
            <div className='boldText p-1'>2. Address Details</div>
            <div className='rows'>
                <div className='column1'>
                    <div className='p-1'>
                        <p>
                            <span className='boldText'>From </span>
                        </p>
                        <p>{data?.ewayBillData?.fromDetails?.name}</p>
                        <p>GSTIN: {data?.ewayBillData?.fromDetails?.gstin}</p>
                        <p>
                            {
                                data?.ewayBillData?.fromDetails?.state
                            }
                        </p>
                    </div>
                    <div className='p-1'>
                        <p>
                            <span className='boldText'>Dispatch From</span>
                        </p>
                        <p>
                            {
                                data?.ewayBillData?.fromDetails?.address
                            }
                            {', '}
                            {
                                data?.ewayBillData?.fromDetails?.city
                            }{' '}
                            {
                                data?.ewayBillData?.fromDetails?.state
                            }{' '}
                            {
                                data?.ewayBillData?.fromDetails?.pinCode
                            }
                        </p>
                    </div>
                </div>
                <div className='column2'>
                    <div>
                        <p>
                            <span className='boldText'>To</span>
                        </p>
                        <p>{data?.ewayBillData?.toDetails?.name}</p>
                        <p>GSTIN: {data?.ewayBillData?.toDetails?.gstin}</p>
                        <p>
                            {
                                data?.ewayBillData?.toDetails?.address
                            }
                        </p>
                    </div>
                    <div>
                        <p>
                            <span className='boldText'>Ship To</span>
                        </p>
                        <p>
                            {
                                data?.ewayBillData?.toDetails?.address
                            }
                            {', '}
                            {
                                data?.ewayBillData?.toDetails?.city
                            }{' '}
                            {
                                data?.ewayBillData?.toDetails?.state
                            }{' '}
                            {data?.ewayBillData?.toDetails?.pinCode}
                        </p>
                    </div>
                </div>
            </div>

            {/* <h3
                    style={{
                      borderBottom: "1px solid black",
                      paddingBottom: "10px",
                    }}
                  >
                    3. Goods Details
                  </h3> */}
            <div
                className='boldText p-1'
                style={{
                    borderBottom: '1px solid black',
                    paddingBottom: '10px',
                }}
            >
                3. Goods Details
            </div>
            <table className='goodsTable'>
                <thead>
                    <tr>
                        <th className='border-right-0'>HSN Code</th>
                        <th className='border-right-0'>
                            Product Name & Desc
                        </th>
                        <th className='border-right-0'>Quantity</th>
                        <th className='border-right-0'>Taxable Amt</th>
                        <th className='border-right-0'>Tax Rate(I)</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.stockList?.map(
                        (product) => (
                            <tr>
                                <td>
                                    <span className='boldText'>310100</span>
                                </td>
                                <td>{product?.product_name}</td>
                                <td>
                                    {product?.quantity}
                                </td>
                                <td>
                                    <span className='boldText'>
                                        {product?.item_amount}
                                    </span>
                                </td>
                                <td>
                                    {product?.igst_rate}
                                </td>
                            </tr>
                        )
                    )}

                    <tr>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <div className='invoiceSectionBorderBottom'>
                <div>
                    <p>
                        Tot. Taxable Amt :
                        <span className='boldText'>
                            {data?.stockList?.reduce((acc, curr) => acc + Number(curr?.item_amount), 0) - (-Number(data?.ledgerList?.find(list => list.name.toLowerCase().includes('discount'))?.amount) || 0)}
                        </span>
                    </p>
                    {data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst'))?.amount && (
                        <p>
                            IGST Amt :
                            <span className='boldText'>
                                {' '}
                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('igst'))?.amount}
                            </span>
                        </p>
                    )}
                    {data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst'))?.amount && (
                        <p>
                            CGST Amt :
                            <span className='boldText'>
                                {' '}
                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('cgst'))?.amount}
                            </span>
                        </p>
                    )}
                </div>
                <div>
                    <p>
                        Other Amt :<span className='boldText'></span>
                    </p>
                    {data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst'))?.amount && (
                        <p>
                            SGST Amt :
                            <span className='boldText'>
                                {' '}
                                {data?.ledgerList?.find(list => list.name.toLowerCase().includes('sgst'))?.amount}
                            </span>
                        </p>
                    )}
                </div>
                <div>
                    <p>
                        Total Inv Amt :
                        <span className='boldText'>
                            {-Number(data?.ledgerList?.find(list => list.name === data?.parsedReplacements?.tallyLedgerName)?.amount).toFixed(2)}
                        </span>
                    </p>
                </div>
            </div>

            {/* <h3>4. Transportation Details</h3> */}
            <div className='boldText p-1'>
                4. Transportation Details
            </div>
            <div className='invoiceSectionBorderBottom'>
                <div>
                    <p>
                        Transporter ID :<span className='boldText'></span>
                    </p>
                    <p>
                        Name :
                        <span className='boldText'>
                            {' '}
                            {
                                data?.ewayBillData?.transportDetails?.transporterName
                            }
                        </span>
                    </p>
                </div>
                <div>
                    <p>
                        Doc No :
                        <span className='boldText'>
                            {' '}
                            {data?.ewayBillData?.transportDetails?.documentNumber}
                        </span>
                    </p>
                    <p>
                        Date :
                        <span className='boldText'>
                            {' '}
                            {moment(
                                data?.ewayBillData?.transportDetails?.documentDate,
                                'YYYYMMDD'
                            ).format('DD-MMM-YYYY')}
                        </span>
                    </p>
                </div>
            </div>
            {/* <h3>4. Vehicle Details</h3> */}
            <div className='boldText p-1'>4. Vehicle Details</div>
            <div className='invoiceSectionBorderBottom border-bottom-0'>
                <p>
                    Vehicle No :
                    <span className='boldText'>
                        {' '}
                        {data?.ewayBillData?.transportDetails?.vehicleNumber}
                    </span>
                </p>
                <p>
                    From :
                    <span className='boldText'>
                        {data?.ewayBillData?.fromDetails?.state}
                    </span>
                </p>
                <p>
                    CEBW No. :<span className='boldText'></span>
                </p>
            </div>
        </div>
    )
}




const pdfJSX = (data) => {
    return (
        <div className='jumBotron invoice-container'>

            {invoiceBill(data)}

            {data?.ewayBillData?.billNumber && (
                <>
                    {ewayBill(data)}
                </>
            )}
        </div>
    );
};

export const printHandlerWithEway = async (values) => {
    const printElement = ReactDOMServer.renderToString(pdfJSX(values));
    // html2pdf().from(printElement).save();
    html2pdf()
        .from(printElement)
        .set({
            filename: `${values?.parsedReplacements?.tallyLedgerName} (${values?.vch_no}).pdf`,
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
          })
        .save();
};